var b2 = "/static/b9a9255d6eeb52ab.png";

export { b2 as default };
//# sourceMappingURL=b_2.png.js.map
